import { render } from "./SlidingMenu.vue?vue&type=template&id=490b2966&scoped=true&ts=true&lang=pug"
import script from "./SlidingMenu.vue?vue&type=script&lang=ts"
export * from "./SlidingMenu.vue?vue&type=script&lang=ts"

import "./SlidingMenu.vue?vue&type=style&index=0&id=490b2966&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490b2966"]])

export default __exports__